import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useState } from "react";
import useCustomPopover from "../../../CustomPopover/hooks/useCustomPopover";
import {
  convertDocxToPdf,
  convertPdfToTable,
} from "../../../../services/tools";
import { displayModalMessage } from "../../../../util/displayMessage";
import { download } from "../../../../util/file";

const MAX_FILE_SIZE = 20480000; // 20MB
const MySwal = withReactContent(Swal);

export const useFileConverterDiva = () => {
  const [file, setFile] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [conversionType, setConversionType] = useState(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [isProcessingFile, setIsProcessingFile] = useState(false);
  const { open, anchorEl, handleClose, handleClick } = useCustomPopover();
  const id = open ? "simple-popover" : undefined;

  const handleConversionTypeSelect = (type) => {
    setConversionType(type);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = e.dataTransfer.files;
    if (!files[0]) return;

    setDataToFileSelected(files[0]);
  };

  const handleFileSelect = (e) => {
    const tempFile = e.target.files[0];
    if (!tempFile) return;

    setDataToFileSelected(tempFile);
  };

  const setDataToFileSelected = (tempFile) => {
    if (!conversionType) {
      MySwal.fire({
        icon: "error",
        title: "Empty Conversion Type",
        text: `Dear user, please select a conversion type.`,
      });
      return;
    }

    if (`.${tempFile.name.split(".")[1]}` !== conversionType.accept) {
      MySwal.fire({
        icon: "error",
        title: "Wrong File Extension",
        text: `File extension for ${conversionType.label} must be ${conversionType.accept}.`,
      });
      return;
    }

    if (tempFile.size > MAX_FILE_SIZE) {
      MySwal.fire({
        icon: "error",
        title: "File Size Exceeded",
        text: "File size must less than 20MB.",
      });
      return;
    }
    setFile({ selectedFile: tempFile });
    setSelectedFile(tempFile);
  };

  const processHandler = async (e) => {
    e.preventDefault();
    setIsProcessingFile(true);
    const formData = new FormData();
    formData.append("source", file.selectedFile);
    formData.append("extension", conversionType.extension);

    const call =
      conversionType.extension === "pdf" ? convertDocxToPdf : convertPdfToTable;

    const fileName = `${file.selectedFile.name.split(".")[0]}.${
      conversionType.extension
    }`;

    call(formData, setIsProcessingFile)
      .then(([status, fileRes]) => {
        if (!status) {
          displayModalMessage(
            "Warning",
            "Dear user, there was a problem uploading your file, please try again",
          );
          return;
        }

        download(fileRes.data, fileName, () => {
          displayModalMessage(
            "Warning",
            "Dear user, there was a problem uploading your file, please try again",
          );
        }).then((r) => {
          if (r) {
            displayModalMessage(
              "Success",
              "File converted correctly",
              "success",
            );
          }
        });
      })
      .finally(() => {
        resetConvertInfo();
        setIsProcessingFile(false);
      });
  };

  const resetConvertInfo = () => {
    setFile(null);
    setSelectedFile(null);
    setConversionType(null);
    setIsProcessingFile(false);
  };
  return {
    file,
    selectedFile,
    conversionType,
    isDragOver,
    isProcessingFile,
    open,
    anchorEl,
    id,
    handleClose,
    handleClick,
    handleConversionTypeSelect,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileSelect,
    processHandler,
    resetConvertInfo,
  };
};
